import { baseDashboard, baseMyJourneys, baseTasks, SidebarSection } from "./shared";

const sidebarItems: SidebarSection[] = [
  { id: "top", items: [baseDashboard, baseTasks, baseMyJourneys] },
];

export default sidebarItems;
